import { render } from "./SignaturePad.vue?vue&type=template&id=4bb9df90&scoped=true"
import script from "./SignaturePad.vue?vue&type=script&lang=ts"
export * from "./SignaturePad.vue?vue&type=script&lang=ts"

import "./SignaturePad.vue?vue&type=style&index=0&id=4bb9df90&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4bb9df90"

export default script